<script>
import FeatureBlock from '@/components/FeatureBlock.vue'
export default {
  name: 'CollaborativeProcess',
  components: {
    FeatureBlock
  },
  data () {
    return {
      patientBackdrop: "background: #bdc5c7;\n" +
          "background: linear-gradient(0deg,rgba(189, 197, 199, 1) 0%, rgba(242, 234, 211, 1) 59%);"
    }
  },
  computed: {
  }
}
</script>
<template>
  <section class="strategic-partnerships">
    <div class="responsive-rows">
      <article class="article-body">
        <header class="mb-4">
          <h2 class="article-title mb-2 filter-light has-text-text">Real-World Care. <span class="has-text-text">One Platform.</span></h2>
          <h3 class="article-subtitle filter-light">
            Patients progress through therapy along varied clinical paths.
            <br>
            OVB supports the full therapy arc across diverse clinical cases.
          </h3>
        </header>
      </article>
      <div class="patient-grid">
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/leo.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Leo</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Amblyopia and Strabismus</div>
              <div class="target">Binocular Control &rarr; Stability &rarr; Carryover</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/sunny.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Sunny</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Brain Injury / Neuro-Rehabilitation</div>
              <div class="target">Visual Tolerance &rarr; Oculomotor Control &rarr; Carryover</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/paisley.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Paisley</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Reading and Academic Challenges</div>
              <div class="target">Visual Foundations  &rarr; Decoding &rarr; Fluency</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/will.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Will</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Athlete</div>
              <div class="target">Baseline &rarr; Precision &rarr; Endurance</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/mason.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Mason</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Neurodivergent + Visual-Motor</div>
              <div class="target">Tolerance &rarr; Scanning &rarr; Integration</div>
            </div>
          </template>
        </feature-block>
        <feature-block
            :has-image="true"
            class="patient-block"
            :image-area-background="patientBackdrop"
        >
          <template #image>
            <div class="image-section">
              <b-image
                  class="patient-image"
                  responsive
                  src="/img/patients/mason_alt.png"
                  alt="patient image"
                  ratio="150x150"
                  aria-hidden="true"
                  :rounded="false"
              />
            </div>
          </template>
          <template #title>
            <div class="name-block">Mason</div>
          </template>
          <template #content>
            <div class="content-section">
              <div class="classification">Neurodivergent + Visual-Motor</div>
              <div class="target">Tolerance &rarr; Scanning &rarr; Integration</div>
            </div>
          </template>
        </feature-block>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
  .patient-grid {
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax(16rem, 1fr));
    grid-gap: 1rem;
    .patient-block {
      .image-section {
        padding: 1rem 1rem 0 1rem;
        .patient-image {
          max-height: 140px;
          max-width: 140px;
        }
      }
      .name-block {
        text-align: center;
      }
      .content-section {
        .classification {
          text-align: center;
          font-weight: $font-semibold;
        }
        .target {
          text-align: center;
        }
      }
    }
  }
</style>
